/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:4322c2f9-5b0a-45ab-b272-879825f865a6",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_xWiXSIK6X",
    "aws_user_pools_web_client_id": "10mgg591m513pl3924n1nehanr",
    "oauth": {},
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_content_delivery_bucket": "amplify-booker-attendee-dev",
    "aws_content_delivery_bucket_region": "eu-west-1",
    "aws_content_delivery_url": "https://dqw1nlnhqu0n8.cloudfront.net",
    "aws_user_files_s3_bucket": "bookerattendee153926-dev",
    "aws_user_files_s3_bucket_region": "eu-west-1",
    "aws_cognito_login_mechanisms": [
        "PREFERRED_USERNAME"
    ]
};


export default awsmobile;
